<div class="form-skeleton">
  <div class="form-skeleton-steps">
    @for (step of steps; track $index) {
      <inexp-skeleton width="6rem" height="1rem" />
    }
  </div>

  <div class="form-skeleton-box">
    <inexp-skeleton width="30%" height="1.5rem" />
    <div class="form-skeleton-fields">
      @for (field of fields; track $index) {
        <div class="form-skeleton-field">
          <inexp-skeleton width="40%" height="0.875rem" />
          <inexp-skeleton width="100%" height="2.75rem" radius="8px" />
        </div>
      }
    </div>
  </div>
</div>
